import { getBaseApiUrl } from '@/config/utils';

export const authorizationApiUrl = (): string =>
  `${getBaseApiUrl()}/shared/authorizations/SAM_Connect`;
